import { render, staticRenderFns } from "./AcitvateResult.vue?vue&type=template&id=bc80a826&scoped=true&"
import script from "./AcitvateResult.vue?vue&type=script&lang=js&"
export * from "./AcitvateResult.vue?vue&type=script&lang=js&"
import style0 from "./AcitvateResult.vue?vue&type=style&index=0&id=bc80a826&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc80a826",
  null
  
)

export default component.exports